
import AutoStockInfo from './AutoStockInfo.vue';
import AuxItems from '../AuxItems.vue';
import BRadioButton from "../../../components/blain-form/BRadioButton.vue";
import BRadioGroup from "../../../components/blain-form/BRadioGroup.vue";
import FulfillmentOptions from '../fulfillment/FulfillmentOptions.vue';
import ListAndRegistry from '../ListAndRegistry.vue';
import ProductStockInfo from '../ProductStockInfo.vue';
import TransitionExpand from 'Src/js/components/transitions/TransitionExpand.vue';
import Vue, { PropType } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ILocalStoreJson } from 'JS/types/LocalStore';
import { IProductDetailProductJson } from 'JS/types/PDP';

@Component({
	name: 'BatteryOptions',
	components: {
		AutoStockInfo,
		AuxItems,
		BRadioGroup,
		BRadioButton,
		FulfillmentOptions,
		ProductStockInfo,
		TransitionExpand,
		ListAndRegistry
	},
})
class BatteryOptions extends Vue {
	@Prop({ type: Object as PropType<IProductDetailProductJson>, required: true })
	readonly product: IProductDetailProductJson;

	@Prop({ type: Object, required: true })
	readonly store: ILocalStoreJson;

	@Prop({ type: Boolean })
	autoServiceInstall: boolean;

	created() {
		const url = new URL(window.location.href);

		if (url.searchParams.has('delivery')) {
			const deliveryType = url.searchParams.get('delivery');
			this.$store.dispatch('setDeliveryType', deliveryType);

			url.searchParams.delete('delivery');
			window.history.replaceState({}, document.title, url.toString());
		}
	}

	changeInstallMethod(): void {
		this.$emit("update:autoServiceInstall",  !this.autoServiceInstall);
	}

	get showSpecialMessageBox(): boolean {
		return this.$store.getters.showSpecialMessageBox;
	}

	get isComingSoon(): boolean {
		return this.$store.getters.isComing;
	}

	get showListAddButton(): boolean {
		return this.isComingSoon || !this.showSpecialMessageBox;
	}
}

export default BatteryOptions;
